import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { deleteUnit as deleteUnitActions } from '../actions';
import { DELETE_UNIT } from '../constants/actionTypes';
import { removeUnit } from '../repository';


function *_deleteUnit(action) {
    const {vtrac, utrac} = action;
    yield put(loadDataAction('deleteUnit'));

    try {
        yield call(removeUnit(vtrac, utrac));
        yield put(deleteUnitActions.success(utrac, vtrac));
        yield put(loadDataSuccessAction('deleteUnit', 'unit.delete.success'));
    } catch (error) {
        yield put(deleteUnitActions.error(error));
        yield put(loadDataErrorAction('deleteUnit', {response: error.response, body: error.body, titleId:'unit.delete.failed'}, action));
    }

}


export function *deleteUnit() {
    yield takeLatest(DELETE_UNIT.REQUEST, _deleteUnit);
}